import { Button } from '../../button';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal';

type MoveAwayConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  onCancel: () => void;
};

export function MoveAwayConfirmationModal({ open, onClose, onProceed, onCancel }: MoveAwayConfirmationModalProps) {
  return (
    <Modal open={open} onClose={onClose} hideCloseButton>
      <ModalHeader>Confirm Navigation</ModalHeader>
      <ModalBody>Changes that you made may not be saved. Are you sure you want to leave?</ModalBody>

      <ModalFooter>
        <Button modal onClick={onCancel}>
          Cancel
        </Button>
        <Button modal as="outline" onClick={onProceed}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}
